import type { Template } from "@/types";

export const SQ_06_H1_V5: Template[] = [
    {
        id: "sq-06-h1v5-01",
        name: "SQ 01 - H1V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h1_v5_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 68, y: 142, width: 287, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 142, width: 286, height: 433, rotation: 0, imageRotation: 0 },
            { id: "3", x: 797, y: 52, width: 557, height: 340, rotation: 0, imageRotation: 0 },
            { id: "4", x: 797, y: 400, width: 181, height: 264, rotation: 0, imageRotation: 0 },
            { id: "5", x: 986, y: 400, width: 180, height: 264, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1174, y: 400, width: 180, height: 264, rotation: 0, imageRotation: 0 }  
        ],
    },

    {
        id: "sq-06-h1v5-02",
        name: "SQ 02 - H1V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h1_v5_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 167, y: 73, width: 383, height: 571, rotation: 0, imageRotation: 0 },
            { id: "2", x: 784, y: 73, width: 189, height: 282, rotation: 0, imageRotation: 0 },
            { id: "3", x: 784, y: 363, width: 189, height: 281, rotation: 0, imageRotation: 0 },
            { id: "4", x: 981, y: 363, width: 189, height: 281, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1178, y: 363, width: 189, height: 281, rotation: 0, imageRotation: 0 },
            { id: "6", x: 981, y: 73, width: 386, height: 282, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h1v5-03",
        name: "SQ 03 - H1V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h1_v5_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 167, y: 73, width: 188, height: 292, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 73, width: 187, height: 292, rotation: 0, imageRotation: 0 },
            { id: "3", x: 167, y: 373, width: 383, height: 271, rotation: 0, imageRotation: 0 },
            { id: "4", x: 784, y: 73, width: 386, height: 571, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1178, y: 73, width: 189, height: 282, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1178, y: 363, width: 189, height: 281, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h1v5-04",
        name: "SQ 04 - H1V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h1_v5_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 67, y: 73, width: 583, height: 357, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 67, y: 438, width: 140, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 215, y: 438, width: 140, height: 206, rotation: 0, imageRotation: 0 },
            { id: "4", x: 363, y: 438, width: 140, height: 206, rotation: 0, imageRotation: 0 },
            { id: "5", x: 511, y: 438, width: 139, height: 206, rotation: 0, imageRotation: 0 },
            { id: "6", x: 882, y: 73, width: 387, height: 571, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h1v5-05",
        name: "SQ 05 - H1V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h1_v5_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 45, y: 122, width: 156, height: 234, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 364, width: 156, height: 231, rotation: 0, imageRotation: 0 },
            { id: "3", x: 208, y: 122, width: 700, height: 473, rotation: 0, imageRotation: 0 },
            { id: "4", x: 916, y: 122, width: 309, height: 473, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1233, y: 122, width: 156, height: 234, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1233, y: 364, width: 156, height: 231, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h1v5-06",
        name: "SQ 06 - H1V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h1_v5_06.png",
        size: [1434, 717],
        style: {},
        slots: [ 
            { id: "1", x: 45, y: 122, width: 156, height: 233, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 363, width: 156, height: 232, rotation: 0, imageRotation: 0 },
            { id: "3", x: 208, y: 122, width: 700, height: 473, rotation: 0, imageRotation: 0 },
            { id: "4", x: 916, y: 122, width: 156, height: 233, rotation: 0, imageRotation: 0 },
            { id: "5", x: 916, y: 363, width: 156, height: 232, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 122, width: 309, height: 473, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h1v5-07",
        name: "SQ 07 - H1V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h1_v5_07.png",
        size: [1434, 717],
        style: {},
        slots: [          
            { id: "1", x: 45, y: 122, width: 156, height: 233, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 363, width: 156, height: 232, rotation: 0, imageRotation: 0 },
            { id: "3", x: 209, y: 122, width: 155, height: 233, rotation: 0, imageRotation: 0 },         
            { id: "4", x: 209, y: 363, width: 155, height: 232, rotation: 0, imageRotation: 0 },
            { id: "5", x: 371, y: 122, width: 701, height: 473, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 122, width: 310, height: 473, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h1v5-08",
        name: "SQ 08 - H1V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h1_v5_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 173, width: 238, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 246, y: 173, width: 248, height: 372, rotation: 0, imageRotation: 0 },
            { id: "3", x: 502, y: 173, width: 566, height: 372, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1076, y: 173, width: 226, height: 372, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1311, y: 173, width: 123, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1311, y: 363, width: 123, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h1v5-09",
        name: "SQ 09 - H1V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h1_v5_09.png",
        size: [1434, 717],
        style: {},
        slots: [         
            { id: "1", x: 73, y: 48, width: 204, height: 306, rotation: 0, imageRotation: 0 },
            { id: "2", x: 73, y: 362, width: 204, height: 306, rotation: 0, imageRotation: 0 },
            { id: "3", x: 284, y: 48, width: 935, height: 620, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1227, y: 48, width: 136, height: 202, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1227, y: 258, width: 136, height: 201, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1227, y: 467, width: 136, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h1v5-10",
        name: "SQ 10 - H1V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h1_v5_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 83, y: 76, width: 762, height: 565, rotation: 0, imageRotation: 0 },
            { id: "2", x: 883, y: 76, width: 231, height: 336, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1122, y: 76, width: 230, height: 336, rotation: 0, imageRotation: 0 },
            { id: "4", x: 883, y: 420, width: 151, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1042, y: 420, width: 151, height: 221, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1201, y: 420, width: 151, height: 221, rotation: 0, imageRotation: 0 }
        ],
    },
];

